import constant from '@/constant'

export { momentLocales } from './momentLocales'

const enData = () => import(/* webpackChunkName: "lang-en" */ '../../../public/languages/AhaSlides_English.json')
const viData = () => import(/* webpackChunkName: "lang-vi" */ '../../../public/languages/AhaSlides_Vietnamese.json')
const esData = () => import(/* webpackChunkName: "lang-es" */ '../../../public/languages/AhaSlides_Spanish.json')
const seData = () => import(/* webpackChunkName: "lang-se" */ '../../../public/languages/AhaSlides_Swedish.json')
const ptData = () => import(/* webpackChunkName: "lang-pt" */ '../../../public/languages/AhaSlides_Portuguese.json')
const frData = () => import(/* webpackChunkName: "lang-fr" */ '../../../public/languages/AhaSlides_French.json')
const deData = () => import(/* webpackChunkName: "lang-de" */ '../../../public/languages/AhaSlides_German.json')
const idData = () => import(/* webpackChunkName: "lang-id" */ '../../../public/languages/AhaSlides_id.json')
const itData = () => import(/* webpackChunkName: "lang-it" */ '../../../public/languages/AhaSlides_Italian.json')
const trData = () => import(/* webpackChunkName: "lang-tr" */ '../../../public/languages/AhaSlides_Turkish.json')
const csData = () => import(/* webpackChunkName: "lang-cs" */ '../../../public/languages/AhaSlides_Czech.json')
const krData = () => import(/* webpackChunkName: "lang-kr" */ '../../../public/languages/AhaSlides_Korean.json')
const noData = () => import(/* webpackChunkName: "lang-no" */ '../../../public/languages/AhaSlides_Norwegian.json')
const jaData = () => import(/* webpackChunkName: "lang-ja" */ '../../../public/languages/AhaSlides_Japanese.json')
const nlData = () => import(/* webpackChunkName: "lang-nl" */ '../../../public/languages/AhaSlides_Dutch.json')
const ruData = () => import(/* webpackChunkName: "lang-ru" */ '../../../public/languages/AhaSlides_Russian.json')
const plData = () => import(/* webpackChunkName: "lang-pl" */ '../../../public/languages/AhaSlides_Polish.json')
const daData = () => import(/* webpackChunkName: "lang-da" */ '../../../public/languages/AhaSlides_Danish.json')
const zhData = () => import(/* webpackChunkName: "lang-zh" */ '../../../public/languages/AhaSlides_Simplified_Chinese.json')
const slData = () => import(/* webpackChunkName: "lang-sl" */ '../../../public/languages/AhaSlides_Slovenia.json')
const siData = () => import(/* webpackChunkName: "lang-si" */ '../../../public/languages/AhaSlides_Slovenia.json')
const skData = () => import(/* webpackChunkName: "lang-sk" */ '../../../public/languages/AhaSlides_Slovakia.json')
const lvData = () => import(/* webpackChunkName: "lang-lv" */ '../../../public/languages/AhaSlides_lv.json')
const elData = () => import(/* webpackChunkName: "lang-el" */ '../../../public/languages/AhaSlides_Greek.json')
const ltData = () => import(/* webpackChunkName: "lang-lt" */ '../../../public/languages/AhaSlides_Lithuanian.json')
const hrData = () => import(/* webpackChunkName: "lang-hr" */ '../../../public/languages/AhaSlides_Croatian.json')
const isData = () => import(/* webpackChunkName: "lang-is" */ '../../../public/languages/AhaSlides_Icelandic.json')
const bgData = () => import(/* webpackChunkName: "lang-bg" */ '../../../public/languages/AhaSlides_Bulgarian.json')
const roData = () => import(/* webpackChunkName: "lang-ro" */ '../../../public/languages/AhaSlides_Romanian.json')
const huData = () => import(/* webpackChunkName: "lang-hu" */ '../../../public/languages/AhaSlides_Hungary.json')
const sqData = () => import(/* webpackChunkName: "lang-sq" */ '../../../public/languages/AhaSlides_Albanian.json')
const srLatData = () => import(/* webpackChunkName: "lang-sr-latn" */ '../../../public/languages/AhaSlides_Serbian_Latin.json')
const srCyrData = () => import(/* webpackChunkName: "lang-sr-cyrl" */ '../../../public/languages/AhaSlides_Serbian_Cyrillic.json')

const messages = {
  en: enData,
  vi: viData,
  es: esData,
  pt: ptData,
  fr: frData,
  de: deData,
  id: idData,
  it: itData,
  tr: trData,
  ja: jaData,
  nl: nlData,
  ru: ruData,
  pl: plData,
  da: daData,
  zh: zhData,
  sl: slData,
  si: siData,
  lv: lvData,
  cs: csData,
  kr: krData,
  no: noData,
  se: seData,
  el: elData,
  lt: ltData,
  hr: hrData,
  is: isData,
  bg: bgData,
  ro: roData,
  sk: skData,
  hu: huData,
  sq: sqData,
  'sr-latn': srLatData,
  'sr-cyrl': srCyrData,
}

const dataMessage = {}

export const getPresenterLanguageFromCdn = async (locale) => {
  if (dataMessage[locale]) {
    return dataMessage[locale]
  }
  let data = null
  try {
    if (locale === 'br') locale = 'pt'
    if (!messages[locale]) {
      locale = 'en'
    }
    const mod = await messages[locale]()
    data = mod.default
    window.localStorage.setItem('aha-default-language', JSON.stringify(data))
    dataMessage[locale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}

export const getPresentingLanguageFromCdn = async (locale) => {
  if (dataMessage[locale]) {
    return dataMessage[locale]
  }
  let data = null
  try {
    if (locale === 'br') locale = 'pt'
    if (!messages[locale]) {
      locale = 'en'
    }
    const mod = await messages[locale]()
    data = mod.default
    dataMessage[locale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}

export const getDefaultLanguageFallback = async () => {
  const defaultLanguageFallbackLocale = constant.defaultFallbackLocale
  if (dataMessage[defaultLanguageFallbackLocale]) {
    return dataMessage[defaultLanguageFallbackLocale]
  }
  let data = null
  try {
    const mod = await messages[defaultLanguageFallbackLocale]()
    data = mod.default
    dataMessage[defaultLanguageFallbackLocale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}
